// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_dVD","cls2":"News-cls2__F0 News-cls1_dVD"};